module.exports = __webpack_public_path__ + "media/images/athletes/268-130799b7193b9bd1d12eb92910b210f6.png";